import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import IconInfo from '@adv-mt/mt-svg-icons/lib/InfoOutline'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS} from '../settings.js'

export function StepTitle({title = '', description, onInfoClick}) {
  const showInfoIcon = typeof onInfoClick === 'function'

  return (
    <div className={`${BASE_CLASS}-step-title-wrapper`}>
      <div className={`${BASE_CLASS}-step-title`}>
        <TitleBasic
          as={titleBasicTags.h2}
          size={titleBasicSizes.m}
          title={title}
          description={description}
          descriptionSize={titleBasicSizes.s}
        />
      </div>
      {showInfoIcon && (
        <div className={`${BASE_CLASS}-step-infoIcon`} onClick={onInfoClick}>
          <IconInfo size={ATOM_ICON_SIZES.medium} />
        </div>
      )}
    </div>
  )
}

StepTitle.displayName = 'StepperFlowStepTitle'
StepTitle.propTypes = {
  description: PropTypes.string,
  onInfoClick: PropTypes.func,
  title: PropTypes.string
}
